import { ROLE_VALUES } from "@noa/api-core";
import { sendMessage, whenSessionReady, useAddMessage, useSetChatbotState } from "@noa/client-store";

/**
 * Sends a predefined prompt into the active session. `onSend` runs once the message has a session — at once,
 * or after the API's warmup — receiving its id; each app uses it to route to /conversation/:id (the same seamless
 * redirect as a typed first message).
 */
export function useSendPredefinedMessage(isSignedIn: boolean, onSend?: (sessionId: string) => void) {
  const addMessage = useAddMessage();
  const setChatbotState = useSetChatbotState();

  return (message: string) => {
    if (!message.trim() || !isSignedIn) return;

    sendMessage(message);

    const created_at = new Date().toISOString();
    addMessage({ role: ROLE_VALUES.USER, content: message, message_id: "", created_at, used_sources: [], feedback: 0 });
    addMessage({ role: ROLE_VALUES.ASSISTANT, content: "", message_id: "", created_at, used_sources: [], feedback: 0 });
    setChatbotState("sending_message");
    // After the API's warmup when it was asleep: the message waited for this session.
    void whenSessionReady().then((sessionId) => onSend?.(sessionId));
  };
}
